import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { GUIDE_PRICES } from "@/lib/quote-pricing";

export function GuidePrices({
  heading = "Guide prices",
  intro = "Clear, upfront cleaning prices for Tidworth and the surrounding area. Final price depends on the size and condition of your property — the instant quote tool gives you an exact figure in under a minute.",
}: {
  heading?: string;
  intro?: string;
}) {
  return (
    <section id="guide-prices" className="scroll-mt-28 py-20 md:py-24 bg-cream/85 backdrop-blur-sm border-y border-border">
      <div className="container-x">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:items-start">
          <div className="max-w-xl">
            <span className="eyebrow">Guide prices</span>
            <h2 className="mt-4 font-display text-3xl md:text-4xl">{heading} for <span className="rainbow-text">cleaning in Tidworth</span>.</h2>
            <p className="mt-4 text-muted-foreground">{intro}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/quote" className="btn-primary">Get a quote <ArrowRight className="h-4 w-4" /></Link>
              <Link to="/pricing" className="btn-outline">See full pricing</Link>
            </div>
            <p className="mt-6 text-xs text-muted-foreground">
              Prices shown are guide rates including products and equipment. No hidden fees, no call-out charges.
            </p>
          </div>

          <div className="rounded-3xl border border-border bg-card overflow-hidden shadow-soft">
            <table className="w-full text-left text-sm">
              <caption className="sr-only">Guide prices for IZHUB cleaning services in Tidworth</caption>
              <thead className="bg-sage-soft/60">
                <tr>
                  <th scope="col" className="px-5 py-3 font-medium text-foreground">Service</th>
                  <th scope="col" className="px-5 py-3 font-medium text-foreground text-right whitespace-nowrap">Guide price</th>
                </tr>
              </thead>
              <tbody>
                {GUIDE_PRICES.map((row) => (
                  <tr key={row.service} className="border-t border-border align-top">
                    <th scope="row" className="px-5 py-4 font-medium text-foreground">
                      {row.label}
                      <span className="block mt-1 text-xs font-normal text-muted-foreground">{row.includes}</span>
                    </th>
                    <td className="px-5 py-4 text-right whitespace-nowrap">
                      <span className="font-display text-lg text-primary">{row.price}</span>
                      <span className="block text-xs text-muted-foreground">{row.unit}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
